import React, { Component } from 'react';
import { Container, Card, CardBody, Button } from 'reactstrap';
import Parse from 'parse';
import axios from 'axios';

import { BusinessInfo, Hours, Additional } from './components';

import logo from '../../assets/icon.png';

class Register extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    submitted: false,
    businessName: '',
    email: '',
    phone: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    suite: '',
    hours: [{ day: 'placeholder', open: 'placeholder', close: 'placeholder' }],
    websiteURL: '',
    videoURL: '',
  };

  handleSubmit = async () => {
    const {
      businessName,
      email,
      phone,
      street,
      city,
      state,
      zip,
      suite,
      hours,
      websiteURL,
      videoURL,
    } = this.state;

    // Parse hourse
    const days = {};

    hours.forEach((hour) => {
      const existing = days[hour.day];
      if (existing) {
        existing.push([hour.open, hour.close]);
        days[hour.day] = existing;
      } else {
        days[hour.day] = [[hour.open, hour.close]];
      }
    });

    // Create business object
    const business = new Parse.Object('Business', {
      name: businessName,
      email,
      phone,
      street,
      city,
      state,
      zip,
      suite,
      hours: days,
      websiteURL,
      videoURL,
    });

    // Geo code address
    const address = encodeURI(`${street}, ${city}, ${state} ${zip}`);
    const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyDl_NYcz9ILkkWS9U1oUsvyWDp-CzzhLh0`);
    const { data } = response;
    const { results, status } = data;

    if (status === 'OK') {
      const location = results[0].geometry.location;
      const { lat: latitude, lng: longitude } = location;
      const geopoint = new Parse.GeoPoint({ latitude, longitude });
      business.set('location', geopoint);
    }

    // Save business
    await business.save();

    this.setState({ submitted: true });
  };

  render() {
    if (this.state.submitted) {
      return (
        <Container
          style={{
            paddingTop: 130,
            paddingBottom: 30,
            paddingLeft: 30,
            paddingRight: 30,
          }}
        >
          <Card>
            <div style={{ top: -100 }} className="App-logo">
              <img src={logo} alt="logo" style={{ height: 200, borderRadius: 20 }} />
            </div>
            <CardBody style={{ marginTop: -100 }}>
              <div>
                <h1 className="display-6">Success</h1>
                <p className="lead">Your business has been submitted.</p>
              </div>
            </CardBody>
          </Card>
        </Container>
      );
    }
    return (
      <Container
        style={{
          paddingTop: 130,
          paddingBottom: 30,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <Card>
          <div style={{ top: -100 }} className="App-logo">
            <img src={logo} alt="logo" style={{ height: 200, borderRadius: 20 }} />
          </div>
          <CardBody style={{ marginTop: -100 }}>
            <div>
              <h1 className="display-6">New Business Submission Form</h1>
              <p className="lead">
                Please provide all of the information below so that we may add your business to the
                People iQ cloud.
              </p>
            </div>
          </CardBody>
          <BusinessInfo
            businessName={this.state.businessName}
            email={this.state.email}
            phone={this.state.phone}
            street={this.state.street}
            city={this.state.city}
            state={this.state.state}
            zip={this.state.zip}
            suite={this.state.suite}
            setBusinessName={businessName => this.setState({ businessName })}
            setEmail={email => this.setState({ email })}
            setPhone={phone => this.setState({ phone })}
            setStreet={street => this.setState({ street })}
            setCity={city => this.setState({ city })}
            setState={state => this.setState({ state })}
            setZip={zip => this.setState({ zip })}
            setSuite={suite => this.setState({ suite })}
          />
          <Hours hours={this.state.hours} setHours={hours => this.setState({ hours })} />
          <Additional
            websiteURL={this.state.websiteURL}
            videoURL={this.state.videoURL}
            setWebsiteURL={websiteURL => this.setState({ websiteURL })}
            setVideoURL={videoURL => this.setState({ videoURL })}
          />
          <CardBody>
            <div className="float-right">
              <Button className="app-button" size="lg">
                Cancel
              </Button>{' '}
              <Button className="app-button-orange" size="lg" onClick={this.handleSubmit}>
                Submit
              </Button>
            </div>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export { Register };



// WEBPACK FOOTER //
// ./src/business/register/register.js